import { Entity, PrimaryGeneratedColumn, ManyToOne, JoinColumn, Column, Index, OneToMany } from "typeorm";
import { LicenseRequest, LicenseTypeQuestion, User } from ".";
import { AnswerAttachment } from "./AnswerAttachment";

@Entity()
@Index(["licenseTypeQuestionId", "licenseRequestId"], { unique: true })
export class LicenseTypeAnswer {
  @PrimaryGeneratedColumn() id: number;

  @Column("int", { nullable: true })
  licenseTypeQuestionId: number;

  @ManyToOne(() => LicenseTypeQuestion)
  @JoinColumn()
  licenseTypeQuestion: LicenseTypeQuestion;

  @Column("int", { nullable: true })
  licenseRequestId: number;

  @ManyToOne(() => LicenseRequest, {
    onDelete: "CASCADE"
  })
  @JoinColumn()
  licenseRequest: LicenseRequest;

  @Column("text") answer: string;

  @Column("int", { nullable: true })
  createdById: number;

  @ManyToOne(() => User)
  @JoinColumn()
  createdBy: User;

  @OneToMany(() => AnswerAttachment, answerAttachment => answerAttachment.licenseTypeAnswer)
  @JoinColumn()
  answerAttachments: AnswerAttachment[];
}
